import { render, staticRenderFns } from "./redchirp-payment-org-controlled-billing-settings.vue?vue&type=template&id=12cb5a36&scoped=true&"
import script from "./redchirp-payment-org-controlled-billing-settings.vue?vue&type=script&lang=js&"
export * from "./redchirp-payment-org-controlled-billing-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb5a36",
  null
  
)

export default component.exports